// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://drzxmokguptvwptuqjcv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRyenhtb2tndXB0dndwdHVxamN2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE1NTA0NTcsImV4cCI6MjA4NzEyNjQ1N30.j82imh1o82JeWGtfcN7FszSa0LNcImDXski4qOpqiw0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});